<template>
<Upload
   	ref="upload"
   	:show-upload-list="false"
	:before-upload="res=>beforeUpload(res)"
   	:on-success="handleSuccess"
   	:format="['jpg','jpeg','png','pdf']"
   	:max-size="20480"
   	:on-exceeded-size="handleMaxSize"
   	accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf"
   	action="/"
   	class="upload">
   	<!-- <div style="width: 58px;height:58px;line-height: 58px;">
       <Icon type="ios-camera" size="20"></Icon>
   	</div> -->
   	<div class="upload-img">
		<div class="upload-img-main" v-if="!img">
			<Icon type="ios-camera" size="20"></Icon>
			<p>点击上传</p>
		</div>
   		<Spin fix v-show="uploadLoading"></Spin>
   	    <img class="head-img" :src="ossImg(img,'s')" v-if="img&&!isPDF">
   	    <img class="head-img" src="/static/images/haierProduct/pdf.png" v-if="img&&isPDF">
   	</div>
   	<div>
   		<a @click.stop="toBig" class="big-img" v-if="img">查看大图</a>
   		<a @click.stop="$emit('on-remove')" class="del-img" v-if="showDel">移除</a>
   	</div>
</Upload>
</template>
<script>
export default {
	props:{
		value:String,
		showDel:Boolean
	},
	data () {
		return {
			img: this.value || '',
			uploadLoading:false
		}
	},
	computed:{
		isPDF(){
        	return this.img && this.img.toLowerCase().endsWith('.pdf');
		}
	},
	methods:{
		handleMaxSize (file) {
			this.alert('图片过大')
			this.uploadLoading = false;
		},
		toBig () {
			if(this.isPDF){
				window.open(this.img)
			} else {
				window.open(this.ossImg(this.img))
			}
		},
		beforeUpload(file){
			// 添加文件格式验证
			const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'application/pdf'];
			const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif', 'pdf'];
			
			// 检查文件类型
			const isValidType = allowedTypes.includes(file.type.toLowerCase());
			
			// 检查文件扩展名
			const fileName = file.name.toLowerCase();
			const fileExtension = fileName.split('.').pop();
			const isValidExtension = allowedExtensions.includes(fileExtension);
			
			if (!isValidType && !isValidExtension) {
				this.alert('仅限上传 .pdf, .png, .jpg, .jpeg 格式文件');
				return false;
			}
			
			this.uploadLoading = true;
			this.ossUpload(file).then(res=>{
				// 更新内部状态
				this.img = res.url;
				// 同步到父组件
				this.$emit('input', res.url);
				this.$emit("on-success",{
					type:'file',
					...res
				})
				this.uploadLoading = false;
			}).catch(err => {
				this.uploadLoading = false;
				this.alert('上传失败');
			})
			return false
        },
		handleSuccess (res,file){
			// if(String(res.code)==='10000000'){
			// 	this.img = res.data;
			// 	this.$emit('input',res.data);
			// 	this.$emit('on-change',res.data)
			// }else{
			// 	this.alert(res.msg)
			// }
			// this.uploadLoading = false;
		}
	},
	watch:{
		value (val) {
			this.img = val || '';
		}
	}
}
</script>
<style scoped>
	.upload{
		width:90px;
		display:inline-block;
		text-align:center;
		/*margin-bottom: 5px;*/
		height:142px;
	}
	.upload-img{
		width: 90px;
		height:110px;
		/*line-height: 110px;*/
		/*padding-top: 20px;*/
		border: 1px #eaeaea dashed;
		border-radius: 4px;
		text-align: center;
		position: relative;
	}
	.upload-img-main{
		padding-top: 20px;
	}
	p{
		color:#999
	}
	.head-img{
		width:100%;
		height:100%;
	}
	.del-img{
		color:red;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/common/uploadImg.vue